import React from "react";
import { DatasetScatterProps } from "../charts/interfaces";
import DatasetScatterChart from "../charts/dataset-scatter-chart/DatasetScatterChart";

export default function ProductTemplateBubbleChart(props: DatasetScatterProps) {
  return <DatasetScatterChart {...props} bubbleChart />;
}
